import { useEffect, useState } from 'react';

import { breakpoints } from '../config/breakpoints';

export const getBreakpoint = (width: number) => {
  if (width <= breakpoints['breakpoint-xs']) return 'breakpoint-xs';
  if (width <= breakpoints['breakpoint-sm']) return 'breakpoint-sm';
  if (width <= breakpoints['breakpoint-md-4']) return 'breakpoint-md-4';
  if (width <= breakpoints['breakpoint-md-3']) return 'breakpoint-md-3';
  if (width <= breakpoints['breakpoint-md-2']) return 'breakpoint-md-2';
  if (width <= breakpoints['breakpoint-md']) return 'breakpoint-md';
  if (width <= breakpoints['breakpoint-lg-4']) return 'breakpoint-lg-4';
  if (width <= breakpoints['breakpoint-lg-3']) return 'breakpoint-lg-3';
  if (width <= breakpoints['breakpoint-lg-2']) return 'breakpoint-lg-2';
  if (width <= breakpoints['breakpoint-lg']) return 'breakpoint-lg';
  return 'breakpoint-xl';
};

// SSR-safe default: the server has no `window`, so seed a desktop width and let
// the mount effect correct it to the real viewport on the client (reading
// `window` directly in the initializer crashes server/prerender rendering).
const SSR_DEFAULT_WIDTH = breakpoints['breakpoint-lg'];
const getInitialWidth = () =>
  typeof window === 'undefined' ? SSR_DEFAULT_WIDTH : window.innerWidth;

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(getInitialWidth);
  const [breakpoint, setBreakpoint] = useState(() =>
    getBreakpoint(getInitialWidth())
  );

  useEffect(() => {
    const handleWindowResize = () => {
      const newWidth = window.innerWidth;
      const newBreakpoint = getBreakpoint(newWidth);

      setWindowWidth(newWidth);
      setBreakpoint((previousBreakpoint) =>
        previousBreakpoint === newBreakpoint
          ? previousBreakpoint
          : newBreakpoint
      );
    };

    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const isMobile = windowWidth <= breakpoints['breakpoint-md-4'];
  const isTabelet = windowWidth <= breakpoints['breakpoint-md-2'];

  return { windowWidth, isMobile, isTabelet };
};

export default useWindowWidth;
